import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export function PricingTable({ service, cta = "book" }) {
  if (!service) return null;
  const isDeep = service.kind === "deep";
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid={`pricing-${service.slug}`}>
      {service.tiers.map((t) => (
        <div key={t.id} className="bg-white rounded-2xl border border-[#E6DEC3] shadow-[0_4px_20px_rgba(44,38,33,0.04)] p-6 hover:border-[#B87333]/40 hover:-translate-y-1 transition-all duration-300 flex flex-col">
          <p className="text-xs uppercase tracking-[0.2em] text-[#B87333] font-semibold">{t.label}</p>
          <div className="mt-3 flex items-baseline gap-1">
            {isDeep && <span className="text-sm text-[#635B52]">from</span>}
            <span className="font-serif text-4xl text-[#2C2621]">${t.price}</span>
          </div>
          <p className="mt-2 text-sm text-[#635B52]">{t.duration_minutes} min appointment</p>
          <div className="mt-4 flex-1" />
          {cta === "book" && !isDeep && (
            <Link to={`/book?service=${service.slug}&tier=${t.id}`} className="mt-4 block text-center bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-4 py-2.5 text-sm transition-all" data-testid={`book-${service.slug}-${t.id}`}>
              Book this
            </Link>
          )}
          {isDeep && (
            <Link to="/get-estimate" className="mt-4 block text-center bg-[#2C2621] hover:bg-[#1E1A17] text-white font-medium rounded-full px-4 py-2.5 text-sm transition-all" data-testid={`estimate-${service.slug}-${t.id}`}>
              Request estimate
            </Link>
          )}
        </div>
      ))}
    </div>
  );
}

export function IncludeList({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-3 text-[#635B52]">
          <span className="mt-1 shrink-0 w-5 h-5 rounded-full bg-[#B87333]/15 text-[#B87333] flex items-center justify-center"><Check size={13} /></span>
          <span className="text-base leading-relaxed">{it}</span>
        </li>
      ))}
    </ul>
  );
}
